import CategoriesDropdown from './categories-dropdown';

export default CategoriesDropdown;
